export const setSEO = ({ title, description, ogTitle, ogDescription, ogType, canonical }) => {
  document.title = title || 'Benz Eatery | Best Restaurant in Phu Quoc';

  const setMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, key);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };

  if (description) {
    setMeta('name', 'description', description);
  }
  if (ogTitle || title) {
    setMeta('property', 'og:title', ogTitle || title);
  }
  if (ogDescription || description) {
    setMeta('property', 'og:description', ogDescription || description);
  }
  if (ogType) {
    setMeta('property', 'og:type', ogType);
  }
  if (canonical) {
    let link = document.querySelector('link[rel="canonical"]');
    if (link) link.setAttribute('href', canonical);
  }
};
